<script lang="ts">
  import PhoneBlack from "../../icons/PhoneBlack.svg"
  import { recommendation } from "../../stores/recommendation"

  import Button from "../Common/Button.svelte"
  import BrandLogo from "./BrandLogo.svelte"
  import CtaUrlButton from "./CtaUrlButton.svelte"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: selectedProductsCount = $recommendation.selectedProductsCount

  function handleGoToCheckoutButtonOnClick () {
    recommendation.checkout()
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: brandDetails = $recommendation.details?.brand

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: ctaPhoneNumber = $recommendation.details?.brand.ctaPhoneNumber
  
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: ctaUrl = $recommendation.details?.brand.ctaUrl

  $: logoTarget = $recommendation.details?.brand.template === "ClearChoice" ? undefined : "_blank"
</script>

<header>
  {#if brandDetails?.storeUrl}
    <a href={brandDetails?.storeUrl} target={logoTarget}>
      <BrandLogo {brandDetails} />
    </a>
  {:else}
    <BrandLogo {brandDetails} />
  {/if}
  <div class="cta-container">
    {#if brandDetails?.storeCartUrl}
      <Button
        class="go-to-checkout-button"
        disabled={selectedProductsCount === 0}
        on:click={handleGoToCheckoutButtonOnClick}
      >
        Go to Checkout ({selectedProductsCount})
      </Button>
    {/if}
    {#if ctaPhoneNumber}
      <a
        class="header-phone-button"
        href="tel:{ctaPhoneNumber}"
      >
        <svelte:component
          this={PhoneBlack}
          class="button-icon"
        />
        {ctaPhoneNumber}
      </a>
    {/if}
    {#if ctaUrl}
      <CtaUrlButton />
    {/if}
  </div>
</header>
